import packageJson from '../../../package.json';
import { SERVICE_WORKER_SCOPE, ENV } from '../../config';
import { setupInterceptors } from './interceptors';

type CurrentScriptType = HTMLElement | SVGScriptElement | null;

async function mockAPI() {
	const { worker } = await import('../browser');

	const result = await worker.start({
		serviceWorker: {
			url: `${packageJson.homepage}/mockServiceWorker.js`,
			options: {
				// Narrow down the scope of the pages that the worker can control.
				scope: SERVICE_WORKER_SCOPE,
			},
		},
	});
	return result;
}

export function isMocks(currentScript: CurrentScriptType) {
	return !!currentScript?.dataset?.mockKey || ENV === 'MOCK';
}

export function setupMocks(currentScript: CurrentScriptType) {
	const mockKey = currentScript?.dataset?.mockKey;

	if (mockKey) {
		const result = setupInterceptors(mockKey);
		return Promise.resolve(result);
	}

	if (ENV === 'MOCK') {
		return mockAPI();
	}

	return Promise.resolve(null);
}
